module.exports = __webpack_public_path__ + "static/media/999309.334f4d08.png";